import {dirtyValues} from '@/lib/react-hook-form-helpers';
import {useForm, UseFormProps} from '@refinedev/react-hook-form';
import {defaultMutationOptions, useDefaultValues} from 'pages/_utils';
import {ReactNode, useCallback, useMemo} from 'react';

export type UseCreateFormProps = {
  resource?: string; // if undefined, it will be taken from formProps.refineCoreProps.resource
  formProps?: UseFormProps;
  transformBeforeSave?: (data: any) => any;
  submitDirtyFieldsOnly?: boolean;
};

export type CreateFormProps = UseCreateFormProps & {children?: ReactNode};

export const useCreateForm = ({
  resource,
  formProps,
  transformBeforeSave,
  submitDirtyFieldsOnly = true,
}: UseCreateFormProps) => {
  // const defaultValues = useDefaultValues();
  const useFormResults = useForm({
    ...formProps,
    refineCoreProps: {
      ...formProps?.refineCoreProps,
      resource: resource || formProps?.refineCoreProps?.resource,
      action: 'create',
      createMutationOptions: defaultMutationOptions,
    },
    defaultValues: formProps?.defaultValues,
  });

  const {
    refineCore: {onFinish},
  } = useFormResults;

  const onFinishHandler = useCallback(
    async function (data) {
      const dirtyOnly = submitDirtyFieldsOnly
        ? dirtyValues(useFormResults.formState.dirtyFields, data)
        : data;
      const transformed = transformBeforeSave?.(dirtyOnly) || dirtyOnly;
      await onFinish(transformed);
    },
    [useFormResults.formState.dirtyFields],
  );

  return useMemo(
    () => ({
      ...useFormResults,
      refineCore: {
        ...useFormResults.refineCore,
        onFinish: onFinishHandler,
      },
    }),
    [useFormResults, useFormResults.refineCore, onFinishHandler],
  );
};
